import * as React from "react"
import {
  Alert02Icon,
  ArrowDown01Icon as ArrowDown01BaseIcon,
  ArrowLeft01Icon,
  ArrowRight01Icon as ArrowRight01BaseIcon,
  ArrowUp01Icon as ArrowUp01BaseIcon,
  ArrowUpRight01Icon,
  Award02Icon,
  Calendar03Icon,
  Cancel01Icon,
  CancelCircleIcon,
  ChartDecreaseIcon,
  ChartIncreaseIcon,
  CheckmarkCircle02Icon,
  CircleIcon as CircleBaseIcon,
  Clock01Icon,
  Clock03Icon,
  Copy01Icon,
  DateTimeIcon,
  Delete02Icon,
  Edit02Icon,
  FilterIcon as FilterBaseIcon,
  FilterRemoveIcon,
  FileViewIcon as FileViewBaseIcon,
  FlashIcon,
  Layers01Icon,
  LeftToRightListBulletIcon,
  LeftToRightListNumberIcon,
  Link01Icon,
  Loading03Icon,
  MoreHorizontalIcon as MoreHorizontalBaseIcon,
  PackageIcon,
  PanelLeftIcon as PanelLeftBaseIcon,
  PlusSignIcon,
  RefreshIcon as RefreshBaseIcon,
  Search01Icon,
  SecurityCheckIcon,
  SortByDown01Icon,
  SortByUp01Icon,
  TextAlignCenterIcon,
  TextAlignLeftIcon,
  TextAlignRightIcon,
  TextBoldIcon,
  TextItalicIcon,
  TextStrikethroughIcon,
  Tick02Icon,
  TransactionHistoryIcon,
  TruckIcon,
  Wallet02Icon,
} from "hugeicons-react"

import { HugeiconsIcon } from "./hugeicons-icon"

type IconProps = Omit<React.ComponentProps<typeof HugeiconsIcon>, "icon">

function createCompatIcon(icon: React.ComponentProps<typeof HugeiconsIcon>["icon"]) {
  return function CompatIcon(props: IconProps) {
    return <HugeiconsIcon icon={icon} {...props} />
  }
}

const AArrowDown = createCompatIcon(SortByDown01Icon)
const AArrowUp = createCompatIcon(SortByUp01Icon)
const AlertTriangle = createCompatIcon(Alert02Icon)
const AlignCenter = createCompatIcon(TextAlignCenterIcon)
const AlignLeft = createCompatIcon(TextAlignLeftIcon)
const AlignRight = createCompatIcon(TextAlignRightIcon)
const ArrowRight = createCompatIcon(ArrowRight01BaseIcon)
const ArrowRightIcon = ArrowRight
const ArrowUp = createCompatIcon(ArrowUp01BaseIcon)
const Award = createCompatIcon(Award02Icon)
const Ban = createCompatIcon(Cancel01Icon)
const Bold = createCompatIcon(TextBoldIcon)
const Boxes = createCompatIcon(PackageIcon)
const CalendarIcon = createCompatIcon(Calendar03Icon)
const Check = createCompatIcon(Tick02Icon)
const CheckCircle2 = createCompatIcon(CheckmarkCircle02Icon)
const CheckIcon = Check
const ChevronDown = createCompatIcon(ArrowDown01BaseIcon)
const ChevronDownIcon = ChevronDown
const ChevronLeftIcon = createCompatIcon(ArrowLeft01Icon)
const ChevronRight = ArrowRight
const ChevronRightIcon = ChevronRight
const ChevronUpIcon = createCompatIcon(ArrowUp01BaseIcon)
const CircleIcon = createCompatIcon(CircleBaseIcon)
const Clock = createCompatIcon(Clock01Icon)
const Clock3 = createCompatIcon(Clock03Icon)
const Copy = createCompatIcon(Copy01Icon)
const Edit = createCompatIcon(Edit02Icon)
const FilterIcon = createCompatIcon(FilterBaseIcon)
const FilterXIcon = createCompatIcon(FilterRemoveIcon)
const FileViewIcon = createCompatIcon(FileViewBaseIcon)
const History = createCompatIcon(TransactionHistoryIcon)
const IconAlertTriangle = AlertTriangle
const IconArrowUpRight = createCompatIcon(ArrowUpRight01Icon)
const IconBolt = createCompatIcon(FlashIcon)
const IconCalendarTime = createCompatIcon(DateTimeIcon)
const IconCheck = Check
const IconClock = Clock3
const IconHistory = History
const IconTrendingDown = createCompatIcon(ChartDecreaseIcon)
const IconTrendingUp = createCompatIcon(ChartIncreaseIcon)
const Italic = createCompatIcon(TextItalicIcon)
const Layers3 = createCompatIcon(Layers01Icon)
const Link2 = createCompatIcon(Link01Icon)
const List = createCompatIcon(LeftToRightListBulletIcon)
const ListOrdered = createCompatIcon(LeftToRightListNumberIcon)
const Loader2 = createCompatIcon(Loading03Icon)
const LoaderIcon = Loader2
const MoreHorizontal = createCompatIcon(MoreHorizontalBaseIcon)
const PanelLeftIcon = createCompatIcon(PanelLeftBaseIcon)
const Plus = createCompatIcon(PlusSignIcon)
const RefreshCw = createCompatIcon(RefreshBaseIcon)
const Search = createCompatIcon(Search01Icon)
const SearchIcon = Search
const ShieldCheck = createCompatIcon(SecurityCheckIcon)
const Strikethrough = createCompatIcon(TextStrikethroughIcon)
const Trash2 = createCompatIcon(Delete02Icon)
const TrendingUp = IconTrendingUp
const TriangleAlert = AlertTriangle
const Truck = createCompatIcon(TruckIcon)
const Wallet = createCompatIcon(Wallet02Icon)
const X = createCompatIcon(Cancel01Icon)
const XCircle = createCompatIcon(CancelCircleIcon)
const XIcon = X

export {
  AArrowDown,
  AArrowUp,
  AlertTriangle,
  AlignCenter,
  AlignLeft,
  AlignRight,
  ArrowRight,
  ArrowRightIcon,
  ArrowUp,
  Award,
  Ban,
  Bold,
  Boxes,
  CalendarIcon,
  Check,
  CheckCircle2,
  CheckIcon,
  ChevronDown,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRight,
  ChevronRightIcon,
  ChevronUpIcon,
  CircleIcon,
  Clock,
  Clock3,
  Copy,
  Edit,
  FilterIcon,
  FilterXIcon,
  FileViewIcon,
  History,
  IconAlertTriangle,
  IconArrowUpRight,
  IconBolt,
  IconCalendarTime,
  IconCheck,
  IconClock,
  IconHistory,
  IconTrendingDown,
  IconTrendingUp,
  Italic,
  Layers3,
  Link2,
  List,
  ListOrdered,
  Loader2,
  LoaderIcon,
  MoreHorizontal,
  PanelLeftIcon,
  Plus,
  RefreshCw,
  Search,
  SearchIcon,
  ShieldCheck,
  Strikethrough,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Truck,
  Wallet,
  X,
  XCircle,
  XIcon,
}
